import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { type WindowModel } from '../models/window.model';

@Injectable({
    providedIn: 'root',
})
export class WindowService {
    private readonly _document = inject(DOCUMENT);

    public document(): Document {
        return this._document;
    }

    /**
     * Returns the window object (`window`) if it's defined in the current context, otherwise undefined.
     * In Server-Side Rendering (SSR) mode, this function always returns undefined.
     * @returns {WindowModel | undefined} The window object (`window`) or undefined.
     */
    public nativeWindow(): WindowModel | undefined {
        return typeof window !== 'undefined' ? window as unknown as WindowModel : undefined;
    }
}
